__webpack_require__.p = "/wwwroot/dist/legacy/";